import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";
import { Button, Flex, Paper, Title } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { CampaignState } from "src/graphql/generated/graphql";
import { RoutePath } from "src/routes";

import { CampaignInquiriesDataGrid } from "../../../components/CampaignInquiriesDataGrid";
import { CampaignInquiryQueryDataType, useCampaignInquiries } from "../../../hooks/campaignInquiries";
import { useSearchInput } from "../../../hooks/searchInput";

export interface CampaignsPageSearchParams extends Record<string, string | string[]> {
    search?: string;
    tenant?: string;
    state?: string;
}

export interface CampaignsInquiriesPageProps {}
export const CampaignsInquiriesPage = ({}: CampaignsInquiriesPageProps) => {
    const { t } = useTranslation(["common"]);

    const [searchParams, setSearchParams] = useSearchParams({} as CampaignsPageSearchParams);

    const { searchExpression } = useSearchInput(searchParams.get("search") ? searchParams.get("search") : undefined);
    const state = searchParams.get("state") ? (searchParams.get("state") as CampaignState) : undefined;

    useEffect(() => {
        const searchParams = {} as CampaignsPageSearchParams;

        if (searchExpression) {
            searchParams.search = searchExpression;
        }

        if (state?.length > 0) {
            searchParams.state = state;
        }

        setSearchParams(searchParams);
    }, [searchExpression, state, setSearchParams]);

    const { campaignInquiries, isLoadingCampaignInquiries } = useCampaignInquiries();

    const handleGetRowHref = useCallback((campaignInquiry: CampaignInquiryQueryDataType) => {
        if (!campaignInquiry) {
            return undefined;
        }

        return {
            path: RoutePath.CAMPAIGN_INQUIRY_DETAIL,
            params: { campaignInquiryId: campaignInquiry.id },
        };
    }, []);

    return (
        <>
            <Flex
                align="center"
                justify="space-between"
                mb="lg"
                pb="lg"
                pt="sm"
                style={{
                    borderBottom: "1px solid #E0E0E0",
                }}
            >
                <Title order={2}>{t("campaigninquiries")}</Title>
                <Button component={Link} leftIcon={<IconPlus size="1em" />} to="/campaigns/inquiry">
                    {t("campaigninquiry_create")}
                </Button>
            </Flex>
            <Paper
                py="lg"
                shadow="sm"
                radius="sm"
                // withBorder
                style={{
                    background: "transparent",
                    boxShadow: "none",
                }}
            >
                <CampaignInquiriesDataGrid
                    campaignInquiries={campaignInquiries}
                    isLoadingCampaignInquiries={isLoadingCampaignInquiries}
                    getRowHref={handleGetRowHref}
                />
            </Paper>
        </>
    );
};
